export const HISTORY_LOG_VARIANT = 'HISTORY_LOG_VARIANT';
export const HISTORY_LOG_DATA = 'HISTORY_LOG_DATA';
export const HISTORY_LOG_COUNT = 'HISTORY_LOG_COUNT';
export const HISTORY_LOG_TOGGLE_MODAL = 'HISTORY_LOG_TOGGLE_MODAL';
export const HISTORY_LOG_OFFSET = 'HISTORY_LOG_OFFSET';
export const HISTORY_LOG_PER_PAGE = 'HISTORY_LOG_PER_PAGE';
export const HISTORY_LOG_LOADING = 'HISTORY_LOG_LOADING';
